import { EntityTypeDeclarationModal } from '@ping/pages/user/portfolio/components/EntityTypeDeclarationModal';
import {
  ImportantNoticeModal,
  PendingForReviewModal,
  UploadDocumentsModal,
  WithdrawTierUpgradingStepModal,
} from '@ping/components';
import { useIsUserLoggedIn } from '@ping/hooks';
import { ReceivedDataModal } from '@ping/pages/user/portfolio/components';

interface IModalProviderProps {
  children: React.ReactNode;
}

export const ModalProvider = (props: IModalProviderProps) => {
  const isUserLoggedIn = useIsUserLoggedIn();

  // TODO: Do we need all of them to be here?
  return (
    <>
      {isUserLoggedIn && (
        <>
          <EntityTypeDeclarationModal />
          <ReceivedDataModal />
          <WithdrawTierUpgradingStepModal />
          <UploadDocumentsModal />
          <PendingForReviewModal />
        </>
      )}

      <ImportantNoticeModal />

      {props.children}
    </>
  );
};
